//
//  Copyright © 2022 Block, Inc. All rights reserved.
//

export interface Posted {
  // eslint-disable-next-line @typescript-eslint/ban-types
  posted: {};
}

const posted: Posted = { posted: {} };
export default posted;

export function isPosted(message: unknown): message is Posted {
  return (message as Posted).posted !== undefined;
}
